import { Form, Input, Select } from "antd";
import React, { useContext } from "react";
import ExpertExpertisesContext from "../../../../../context/expertExpertisesContext";
import ExpertDataContext from "../../../../../context/expertDataContext";

function ExpertisesModal({ data, expertisesOptions, defaults }) {
  const {
    farmsIdsActions,
    gardensIdsActions,
    earthenGreenHouseIdsActions,
    hydroponicGreenHouseIdsActions,
    liveStockIdsAction,
    veterinaryIdsAction,
  } = useContext(ExpertExpertisesContext);

  const { expertDataAction } = useContext(ExpertDataContext);

  //defaults
  const defaultFarms = defaults?.defaultFarms;
  const defaultGardens = defaults?.defaultGardens;
  const defaultEarthenGreenHouse = defaults?.defaultEarthenGreenHouse;
  const defaultHydroponicGreenHouse = defaults?.defaultHydroponicGreenHouse;
  const defaultLiveStock = defaults?.defaultLiveStock;
  const defaultVeterinary = defaults?.defaultVeterinary;

  const farmsOptions = expertisesOptions
    ?.filter((item) => item?.categoryEN === "EXPERTISES_FARMS")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  const gardensOptions = expertisesOptions
    ?.filter((item) => item?.categoryEN === "EXPERTISES_GARDENS")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  const earthenGreenHouseOptions = expertisesOptions
    ?.filter((item) => item?.categoryEN === "EXPERTISES_EARTHEN_GREENHOUSE")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  const hydroponicGreenHouseOptions = expertisesOptions
    ?.filter((item) => item?.categoryEN === "EXPERTISES_HYDROPONIC_GREENHOUSE")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  const liveStockOptions = expertisesOptions
    ?.filter((item) => item?.categoryEN === "EXPERTISES_LIVESTOCK_POULTRY")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  const veterinaryOptions = expertisesOptions
    ?.filter((item) => item?.categoryEN === "EXPERTISES_VETERINARY_MEDICINE")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  const defaultOtherExpertises = data?.otherExpertises;

  const handleChange = (e) => {
    
      expertDataAction(e?.target?.name, e?.target?.value);
      
  
  };

  const changeHanlder1 = (value) => {
    gardensIdsActions(value);
  };

  const changeHanlder2 = (value) => {
    farmsIdsActions(value);
  };

  const changeHanlder3 = (value) => {
    earthenGreenHouseIdsActions(value);
  };

  const changeHanlder4 = (value) => {
    hydroponicGreenHouseIdsActions(value);
  };

  const changeHanlder5 = (value) => {
    liveStockIdsAction(value);
  };

  const changeHanlder6 = (value) => {
    veterinaryIdsAction(value);
  };

  return (
    <Form layout="vertical">
      <section className="flex flex-row max-lg:flex-col justify-evenly gap-3">
        <Form.Item label=" باغات " className="w-1/2 max-lg:w-full">
          <Select
            className="font-body"
            defaultValue={defaultGardens}
            mode="multiple"
            clearIcon
            options={gardensOptions}
            onChange={changeHanlder1}
            showSearch={false}
          />
        </Form.Item>
        <Form.Item label="مزارع" className="w-1/2 max-lg:w-full">
          <Select
            className="font-body"
            defaultValue={defaultFarms}
            mode="multiple"
            clearIcon
            options={farmsOptions}
            onChange={changeHanlder2}
            showSearch={false}
          />
        </Form.Item>
      </section>
      <section className="flex flex-row max-lg:flex-col justify-evenly gap-3">
        <Form.Item label="گلخانه خاکی" className="w-1/2 max-lg:w-full">
          <Select
            className="font-body"
            defaultValue={defaultEarthenGreenHouse}
            mode="multiple"
            clearIcon
            options={earthenGreenHouseOptions}
            onChange={changeHanlder3}
            showSearch={false}
          />
        </Form.Item>
        <Form.Item label="گلخانه هیدروپونیک" className="w-1/2 max-lg:w-full">
          <Select
            className="font-body"
            defaultValue={defaultHydroponicGreenHouse}
            mode="multiple"
            clearIcon
            options={hydroponicGreenHouseOptions}
            onChange={changeHanlder4}
            showSearch={false}
          />
        </Form.Item>
      </section>

      <section className="flex flex-row max-lg:flex-col justify-evenly gap-3">
        <Form.Item label="دام و طیور" className="w-1/2 max-lg:w-full">
          <Select
            className="font-body"
            defaultValue={defaultLiveStock}
            mode="multiple"
            clearIcon
            options={liveStockOptions}
            onChange={changeHanlder5}
          />
        </Form.Item>
        <Form.Item label="دامپزشکی" className="w-1/2 max-lg:w-full">
          <Select
            className="font-body"
            defaultValue={defaultVeterinary}
            mode="multiple"
            clearIcon
            options={veterinaryOptions}
            onChange={changeHanlder6}
          />
        </Form.Item>
      </section>

      <Form.Item label="سایر تخصص ها">
        <Input
          defaultValue={defaultOtherExpertises ? defaultOtherExpertises : ""}
          placeholder="اگر تخصص ویژه مورد نظر شما در لیست های بالا نبود در این قسمت وارد کنید..."
          onChange={handleChange}
          name="otherExpertises"
        />
      </Form.Item>
    </Form>
  );
}

export default ExpertisesModal;
